export default __webpack_public_path__ + "static/media/time-to-relax.40251244.md";